import { request } from "../utils/request";

// Public organizer endpoints. None of these require auth, but the shared
// `request` instance attaches a bearer token when one exists — the profile
// endpoint uses it to resolve `following` / `is_self` for the viewer.
//
// Every path takes the organizer's PUBLIC identifier — their username slug
// ("maragh-ent"), never the numeric user id. The API also accepts a slug
// retired by a rename, and a legacy numeric id, on all three.
//
// The API still answers the older /host/* prefix as a silent alias, but
// nothing here emits it: the frontend only ever calls /organizer/*.
export default {
    // GET /organizer/{identifier} → { host, stats, following, is_self, upcoming_events, past_events }
    getProfile: (identifier, signal) => request.get(`/organizer/${identifier}`, { signal }),

    // POST /organizer/{slug}/follow → { following, followers_count }. Auth required.
    follow: (slug) => request.post(`/organizer/${slug}/follow`),

    // DELETE /organizer/{slug}/follow → { following, followers_count }. Auth required.
    unfollow: (slug) => request.delete(`/organizer/${slug}/follow`),
};
